import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSite } from '../../../store/authReducer';
import { selectMultiSiteSelection } from '../../site-selection/reducer';
import { getOverviewWashCounts } from '../actions';
import { selectMyChartsWashCounts } from '../reducer';
import StackedBarChart from './StackedBarChart';
import { useAppContext } from '../../../providers/AppProvider';

interface Props {
  fromDate: any;
  untilDate: any;
  hourlyWashCounts: {
    count: number;
    countByProduct: { [key: string]: number };
    countsBySiteId: { [key: number]: number };
  }[];
  closestHourly: {
    count: number;
    countByProduct: { [key: string]: number };
    countsBySiteId: { [key: number]: number };
  }[];
}
const WashCountsChartDataGetter = (props: Props) => {
  const dispatch = useDispatch();
  const tz = useAppContext().timeZone;
  const primarySiteId = useSelector(selectSite),
    multiSiteSelection = useSelector(selectMultiSiteSelection);
  const fetchWashCounts = () => {
    dispatch(getOverviewWashCounts(moment.tz(props.fromDate, tz).toISOString()));
  };
  useEffect(fetchWashCounts, [
    props.fromDate,
    primarySiteId,
    multiSiteSelection,
    props.hourlyWashCounts,
    tz,
  ]);
  return (
    <StackedBarChart
      hourlyWashCounts={props.hourlyWashCounts}
      closestHourlyWashCounts={props.closestHourly}
      fromDate={props.fromDate}
      untilDate={props.untilDate}
    />
  );
};

export default WashCountsChartDataGetter;
